<template>
    <div class="main_bd">
        <div class="head_title">Marketing Pages Management</div>
        <div class="action_content">
            <div>
                <button style="width: 260px;" class="action_btn active_btn" @click="turn_to_create">Create new page</button>
            </div>
        </div>
        <div class="mod_default_box permission">
            <a-table :pagination="false" :rowKey="data => data.id" :columns="columns" :data-source="pages_list" >
                <div slot="action" slot-scope="text, data">
                    <div>
                        <div style="height: 10px"></div>
                        <a-button type="primary" @click="turn_to_create(data)">Edit</a-button>
                    </div>
                </div>
                <div slot="cover_image" slot-scope="text">
                    <img :src="text" style="width: 100px; height: 100px;" />
                </div>
            </a-table>
            <a-pagination style="margin-top: 5px;" @change="turnPage" :pageSize="20" v-model="cur_page" :total="total_count"
                show-less-items />
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    import VueSweetalert2 from "vue-sweetalert2";
    Vue.use(VueSweetalert2);

    import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';

    const columns = [
        {
            title: "Page ID",
            dataIndex: "page_id",
            width: 150
        },
        {
            title: "Title",
            dataIndex: "title",
        },
        {
            title: "Body",
            dataIndex: "body",
        },
        {
            title: "Cover Image",
            dataIndex: "cover_image",
            scopedSlots: { customRender: 'cover_image' },
            width: 150
        },
        {
            title: "Related Merchant",
            dataIndex: "related_user_name",
            width: 150
        },
        {
            title: "Update time",
            dataIndex: "update_time",
            width: 150
        },
        {
            title: "Action",
            dataIndex: "related_sid",
            scopedSlots: { customRender: 'action' },
            width: 100
        },
    ];

    export default {
        name: 'pages_list',
        components: {
        },
        data() {
            return {
                sid: window.localStorage.getItem('sid'),
                columns,
                cur_page: 1,
                total_page: 0,
                total_count: 0,
                pages_list: []
            };
        },
        beforeMount() {
            let _sid = window.localStorage.getItem('sid') || '';
            let _token = window.localStorage.getItem('token') || '';

            if (!_sid || !_token) {
                window.location.replace('/login');
            }
        },
        async created() {
            this.get_pages_list();
        },
        watch: {
        },
        mounted() {

        },
        computed: {
            ...mapGetters({}),
            ...mapState({})
        },
        methods: {
            ...mapActions({
                getPagesList: 'market/getPagesList',
            }),
            ...mapMutations({
                set_msg: 'app/APP_SET_MSG'
            }),
            async get_pages_list() {
                let { list, total_count, total_page } = await this.getPagesList({
                    page: this.cur_page,
                    page_size: 20,
                });

                this.pages_list = list;
                this.total_page = total_page;
                this.total_count = total_count;
            },
            turnPage(e) {
                this.get_pages_list();
            },
            turn_to_create(data) {
                this.$router.push({
                    path: data.page_id ? '/market/pages/create?page_id=' + data.page_id : '/market/pages/create'
                });
            },
        }
    };
</script>

<style>
</style>